// Port of api/fuel/app/classes/insights/game/overview.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'overview',
    priority: 9,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var username = owner.get_name().toLowerCase()
        var game = this._data.game
        var collection = this._data.collection
        var rating = this._data.rating
        var playsRaw = this._data.plays_raw
        var playersRaw = this._data.players_raw
        var version = this._data.version
        var totalPlays = this._data.totalPlays
        var totalSessions = this._data.totalSessions

        var overview = {
            firstPlayed: null,
            lastPlayed: null,
            daysSinceLastPlay: null,
            totalPlays: totalPlays,
            totalSessions: totalSessions,
            avgPlaysPerMonth: null,
            totalPlayTime: null,
            avgPlayTimePerSession: null,
            longestSession: null,
            userRating: null,
            bggAvgRating: null,
            ratingDelta: null,
            ratingDate: null,
            dateOwned: null,
            dateAcquired: null,
            value: null,
            costPerPlay: null,
            daysInCollection: null,
            versionName: null,
            winCount: 0,
            winRate: null,
            dateWishlisted: null,
            dateRemoved: null,
            ratingTrend: [],
            yearlyAverage: null,
            totalPlayers: 0
        }

        // --- Play KPIs ---
        if (totalSessions) {
            var firstPlay = playsRaw[0]
            var lastPlay = playsRaw[totalSessions - 1]

            overview.firstPlayed = parseInt(firstPlay.play_date, 10) || 0
            overview.lastPlayed = parseInt(lastPlay.play_date, 10) || 0

            if (overview.lastPlayed > 0) {
                overview.daysSinceLastPlay = Math.floor((Util.time() - overview.lastPlayed) / Constants.TIME_DAY)
            }

            if (overview.firstPlayed > 0 && overview.lastPlayed > 0) {
                var monthSpan = Math.max(1, Math.round((overview.lastPlayed - overview.firstPlayed) / Constants.TIME_MONTH) + 1)
                overview.avgPlaysPerMonth = Math.round(totalPlays / monthSpan * 100) / 100
            }

            var totalPlayTime = 0
            var longestSession = 0
            var sessionsWithTime = 0

            for (var pi = 0; pi < playsRaw.length; pi++) {
                var length = parseInt(playsRaw[pi].play_length, 10) || 0
                if (length > 0) {
                    totalPlayTime += length
                    sessionsWithTime++
                    if (length > longestSession) longestSession = length
                }
            }

            overview.totalPlayTime = totalPlayTime
            if (sessionsWithTime > 0) overview.avgPlayTimePerSession = Math.round(totalPlayTime / sessionsWithTime)
            if (longestSession > 0) overview.longestSession = longestSession
        }

        // --- Rating KPIs ---
        if (rating) {
            overview.userRating = parseFloat(rating.get_value()) || 0
            overview.ratingDate = parseInt(rating.get_date(), 10) || 0
        }

        overview.bggAvgRating = parseFloat(game.get_rating_avg()) || 0

        if (overview.userRating && overview.bggAvgRating) {
            overview.ratingDelta = Math.round((overview.userRating - overview.bggAvgRating) * 100) / 100
        }

        // --- Collection KPIs ---
        if (collection) {
            overview.dateOwned = collection.get_date_owned() ? parseInt(collection.get_date_owned(), 10) : null
            overview.dateAcquired = collection.get_date_acquired() ? parseInt(collection.get_date_acquired(), 10) : null
            overview.value = collection.get_value() ? parseFloat(collection.get_value()) : null

            if (overview.value && totalPlays > 0) {
                overview.costPerPlay = Math.round((overview.value / totalPlays) * 100) / 100
            }

            var ownedDate = overview.dateOwned || overview.dateAcquired
            if (ownedDate) {
                overview.daysInCollection = Math.floor((Util.time() - ownedDate) / Constants.TIME_DAY)
            }
        }

        // Version name
        if (version) {
            overview.versionName = version.get_name()
        }

        // --- Status date logs ---
        var game_id = parseInt(vars.id, 10)

        var statusDates = Util.queryFast(
            'SELECT log_status, log_context, log_date FROM log_user_collection_status ' +
            'WHERE user_id = ' + user_id + ' AND game_id = ' + game_id +
            ' AND log_initial_sync != 1' +
            ' AND log_status IN(' + Constants.COLLECTION_STATUS_WISHLIST + ', ' + Constants.COLLECTION_STATUS_OWN + ')' +
            ' ORDER BY log_date ASC'
        )

        for (var si = 0; si < statusDates.length; si++) {
            var row = statusDates[si]
            var status = parseInt(row.log_status, 10)
            var context = parseInt(row.log_context, 10)
            var date = parseInt(row.log_date, 10)

            if (status === Constants.COLLECTION_STATUS_WISHLIST && context === Constants.LOG_CONTEXT_ADDED && !overview.dateWishlisted) {
                overview.dateWishlisted = date
            }
            if (status === Constants.COLLECTION_STATUS_OWN && context === Constants.LOG_CONTEXT_REMOVED) {
                overview.dateRemoved = date
            }
        }

        // --- Rating revision trend ---
        var revisionsRaw = Util.queryFast(
            'SELECT l.log_rating AS rating FROM log_user_rating l ' +
            'WHERE l.game_id = ' + game_id + ' AND l.user_id = ' + user_id +
            ' AND l.log_initial_sync != 1 ORDER BY l.log_date ASC'
        )

        overview.ratingTrend = []
        for (var ri = 0; ri < revisionsRaw.length; ri++) {
            overview.ratingTrend.push(parseFloat(revisionsRaw[ri].rating))
        }

        // --- Win KPIs ---
        var winCount = 0
        var userPlayCount = 0

        for (var wi = 0; wi < playersRaw.length; wi++) {
            if (!this.isSelf(playersRaw[wi], user_id, username)) continue
            userPlayCount++
            if (parseInt(playersRaw[wi].player_win, 10)) winCount++
        }

        overview.winCount = winCount
        if (userPlayCount > 0) {
            overview.winRate = Math.round((100 / userPlayCount) * winCount * 10) / 10
        }

        // --- Yearly average plays ---
        if (totalSessions > 0) {
            var firstDate = parseInt(playsRaw[0].play_date, 10) || 0
            var lastDate = parseInt(playsRaw[totalSessions - 1].play_date, 10) || 0

            if (firstDate > 0 && lastDate > 0) {
                var yearSpan = Math.max(1, Math.round((lastDate - firstDate) / Constants.TIME_YEAR) + 1)
                overview.yearlyAverage = Math.round(totalPlays / yearSpan * 10) / 10
            }
        }

        // --- Total unique opponents ---
        var opponents = {}

        for (var oi = 0; oi < playersRaw.length; oi++) {
            if (parseInt(playersRaw[oi].user_id, 10) !== user_id) {
                var key = playersRaw[oi].player_username || playersRaw[oi].player_name
                if (key) opponents[key] = true
            }
        }

        overview.totalPlayers = Object.keys(opponents).length

        return {
            overview: overview
        }

    }
})
